import { render, staticRenderFns } from "./EmptyAction.vue?vue&type=template&id=49ec017a&"
import script from "./EmptyAction.vue?vue&type=script&lang=js&"
export * from "./EmptyAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ec017a')) {
      api.createRecord('49ec017a', component.options)
    } else {
      api.reload('49ec017a', component.options)
    }
    module.hot.accept("./EmptyAction.vue?vue&type=template&id=49ec017a&", function () {
      api.rerender('49ec017a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/actions/EmptyAction.vue"
export default component.exports